import React from "react";
import "./Booknowlaundry.css";
// exports default Booknowlaundry
// import BookNowContanct from "../BookNowContanct/BookNow"
import HowtoWork from "./HowTowork/HowtoWork";
export default function Booknowlaundry() {
  return (
 <div className="container-fluid px-4 mt-5">
  <HowtoWork />

  <h5 className="mb-3">Find Our Laundry Location</h5>

  <div className="map-responsive">
    <iframe
      src="https://www.google.com/maps?q=Dubai&t=&z=13&ie=UTF8&iwloc=&output=embed"
      title="Laundry Location"
      loading="lazy"
      width="100%" height="80%"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
</div>
  );
}

